import React, { useState, useEffect } from 'react'
import {
  Button,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  ListGroup,
  ListGroupItem,
  Spinner,
  Badge
} from 'reactstrap'
import { getOnlineAgents } from '../../helpers/chat_helper'

const TransferModal = ({ isOpen, toggle, onTransfer, currentAgentId }) => {
  const [agents, setAgents] = useState([])
  const [selectedAgent, setSelectedAgent] = useState(null)
  const [loading, setLoading] = useState(false)

  useEffect(() => {
    if (isOpen) {
      loadAgents()
    }
  }, [isOpen])

  const loadAgents = async () => {
    try {
      setLoading(true)
      const response = await getOnlineAgents()
      const data = response?.data?.data || response?.data || []
      // Filter out current agent
      let availableAgents = data.filter(a => a.user_id !== currentAgentId)
      console.log('currentAgentId', currentAgentId)
      // Sort by current_chat_count (free agents first)
      availableAgents = availableAgents.sort((a, b) =>
        (a.current_chat_count || 0) - (b.current_chat_count || 0)
      )
      setAgents(availableAgents)
    } catch (error) {
      console.error('Error loading agents:', error)
      setAgents([])
    } finally {
      setLoading(false)
    }
  }

  const handleTransfer = () => {
    if (selectedAgent && onTransfer) {
      onTransfer(selectedAgent.user_id)
      setSelectedAgent(null)
      toggle()
    }
  }

  return (
    <Modal isOpen={isOpen} toggle={toggle}>
      <ModalHeader toggle={toggle}>Transfer Conversation</ModalHeader>
      <ModalBody>
        {loading ? (
          <div className="text-center py-4">
            <Spinner color="primary" />
          </div>
        ) : agents.length > 0 ? (
          <ListGroup flush>
            {agents.map((agent) => (
              <ListGroupItem
                key={agent.id}
                action
                active={selectedAgent?.id === agent.id}
                onClick={() => setSelectedAgent(agent)}
                style={{ cursor: 'pointer' }}
              >
                <div className="d-flex justify-content-between align-items-center">
                  <div>
                    <h6 className="mb-0">
                      {agent.user?.first_name} {agent.user?.last_name}
                    </h6>
                    <small className="text-muted">{agent.user?.email}</small>
                  </div>
                  <div>
                    <Badge color={agent.status === 'online' ? 'success' : 'warning'}>
                      {agent.status}
                    </Badge>
                    {(agent.current_chat_count || 0) === 0 && (
                      <Badge color="success" className="ms-1">
                        Recommended
                      </Badge>
                    )}
                    <small className="d-block text-muted">
                      {agent.current_chat_count}/{agent.max_concurrent_chats} chats
                    </small>
                  </div>
                </div>
              </ListGroupItem>
            ))}
          </ListGroup>
        ) : (
          <div className="text-center text-muted py-4">
            <i className="mdi mdi-account-off-outline" style={{ fontSize: '48px' }}></i>
            <p className="mt-2">No available agents online</p>
          </div>
        )}
      </ModalBody>
      <ModalFooter>
        <Button color="secondary" onClick={toggle}>Cancel</Button>
        <Button color="primary" onClick={handleTransfer} disabled={!selectedAgent}>
          Transfer
        </Button>
      </ModalFooter>
    </Modal>
  )
}

export default TransferModal
